'use client'

import {
  handleAdIntersection,
  useIntersectionObserver,
} from '@/app/hooks/useIntersectionObserver'
import { AdBannerScheduleType } from '@/app/types/adType'
import { getAdsIndex, handleAdClick } from '@/app/utils/AdsUtility'
import { languageTransition } from '@/app/utils/language'
import { useNavigation } from '@/app/utils/navigation'
import Image from 'next/image'
import { useParams } from 'next/navigation'
import { useEffect, useRef } from 'react'
const NewsDetailAds = ({
  lng,
  adBanner,
}: {
  lng: string
  adBanner: AdBannerScheduleType[]
}) => {
  const { redirectToAdvertise } = useNavigation()
  const localeLangauge = languageTransition.find(
    (item) => item.path == lng
  )?.language
  const adPositionFiveRef = useRef<HTMLDivElement>(null)

  const adForPositionFive = adBanner[getAdsIndex(adBanner, 'Ad Position 5')]
  const observeElement = useIntersectionObserver(handleAdIntersection)
  const params = useParams<{ lng: string }>()

  useEffect(() => {
    if (adPositionFiveRef.current) {
      observeElement(adPositionFiveRef.current)
    }
  }, [adForPositionFive, observeElement])
  return (
    <div className="relative cursor-pointer w-[843px] h-[220px] mobile-width">
      <div
        className='ad_banner_gtm'
        ref={adPositionFiveRef}
        data-ad-position="Ad Position 5"
        data-ad-id={adForPositionFive?.ad_banner?.id}
        data-ad-sid={adForPositionFive?.id}
        data-ad-page={adForPositionFive?.page?.name}
        data-ad-company-id={adForPositionFive?.ad_banner?.company?.id}
        data-ad-lang={params?.lng}
      >
        {adForPositionFive ? (
          <Image
            priority
            width={843}
            height={220}
            src={adForPositionFive?.ad_banner?.image}
            alt=""
            className="object-cover w-full h-full"
            id="ad_click"
            onClick={() => handleAdClick(adForPositionFive, lng)}
          />
        ) : (
          <Image
            priority
            width={843}
            height={220}
            className="object-cover cursor-pointer w-full h-full"
            src={`/assets/image/FructidorAds/${localeLangauge}/NewsDetail/Ad5 843x220.png`}
            alt=""
            onClick={redirectToAdvertise}
          />
        )}
      </div>
    </div>
  )
}

export default NewsDetailAds
